import React from 'react';
import PropTypes from 'prop-types';

const IconMaterialsDesigned = props => {
  const color = props.color || '#585858';
  return (
    <svg width={35} height={34} viewBox="0 0 35 34" {...props}>
      <g stroke={color} strokeWidth={2} fill="none" fillRule="evenodd">
        <path d="M32.483 14.17c.954 4.92-.476 10.213-4.288 14.024-6.1 6.1-15.987 6.1-22.086 0-6.102-6.097-6.102-15.988 0-22.085 6.099-6.101 15.987-6.101 22.086 0" />
        <path
          strokeLinejoin="round"
          d="M33.873 3.831L15.948 21.593l-6.88-6.973"
        />
      </g>
    </svg>
  );
};

IconMaterialsDesigned.propTypes = {
  color: PropTypes.string,
};

export default IconMaterialsDesigned;
